let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("59nfi")).then(() => parcelRequire('5mpB2'));